import { render, staticRenderFns } from "./projectSetScoringFrom.vue?vue&type=template&id=09ebafa9&scoped=true&"
import script from "./projectSetScoringFrom.vue?vue&type=script&lang=js&"
export * from "./projectSetScoringFrom.vue?vue&type=script&lang=js&"
import style0 from "./projectSetScoringFrom.vue?vue&type=style&index=0&id=09ebafa9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ebafa9",
  null
  
)

export default component.exports